import { render, staticRenderFns } from "./merchant.vue?vue&type=template&id=4bae44cd&scoped=true&"
import script from "./merchant.vue?vue&type=script&lang=js&"
export * from "./merchant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bae44cd",
  null
  
)

export default component.exports